import { useContext } from 'react';
import { getLabel } from '../../../data/labels';
import { convertInAlternativeCurrency } from '../../../data/utils/convertInAlternativeCurrency';
import { formatDate } from '../../../data/utils/formatDate';
import { getCheckbetUrl } from '../../../data/utils/getCheckbetUrl';
import { getConfiguration } from '../../../data/utils/configuration';
import { getCurrencySymbol } from '../../../data/utils/getCurrencySymbol';
import { getHiddenTicket } from '../../../data/utils/getHiddenTicket';
import { getPrintableAmount } from '../../../data/utils/getPrintableAmount';
import { oddToString } from '../../../data/utils/oddToString';
import { CashoutConfigurationContext } from '../../cashout/CashoutConfigurationCtx';
import { TicketPrinterContext } from '../../printer/TicketPrinterContext';
import { MyBetsContext } from './MyBetsContext';
import ReloadTicketSection from './ReloadTicketSection';
import Winnings from './Winnings';
import { getEnv } from '../../env';
import ShareCardDownloader from './ShareCardDownloader';

function getTicketType(type) {
    switch (type) {
        case 'singlebets':
            type = getLabel('mybets.singola');
            break;
        case 'multibets':
            type = getLabel('mybets.multipla');
            break;
        case 'systembets':
            type = getLabel('mybets.sistema');
            break;
        default:
            break;
    }

    return type;
}

function BetInfo(props) {
    const ticket = props.ticket;
    const conf = getConfiguration();
    const cashoutConfigurationContext = useContext(CashoutConfigurationContext);
    const printTicketEnabled = conf.pto !== undefined ? conf.pto : true;
    const currency = getCurrencySymbol(conf.cs.ct);
    const isCashoutable = (cashoutConfigurationContext.cashoutData.enabled && ticket.isCashoutable && !props.isCheckbet);
    const myBetsContext = useContext(MyBetsContext);
    const printerContext = useContext(TicketPrinterContext);
    const ticketUrl = getCheckbetUrl(ticket.id);
    const amount = getPrintableAmount(ticket.cashoutAmount, conf.cs.m, conf.cs.nd);
    const amountAltCurr = convertInAlternativeCurrency(ticket.amount);
    const amountWithCurrency = `${amount} ${currency}`;
    const bonusAmount = ticket.bonusAmount || props.ticketData?.bonusAmount;
    const frontendVersion = getEnv('REACT_APP_FRONTEND_VERSION');

    let disclaimerCashout = getLabel('cashout.disclaimer');
    disclaimerCashout = disclaimerCashout.replace(/{{AMOUNT}}/g, amountWithCurrency);

    const totalOdd = props.isBetBuilder && props.typeOfBetBuilder === 'ESTERO' ? ticket.betBuilderTotalOdd : ticket.totalOdds;
    const eventsCount = ticket.eventsCount || ticket.events?.length || '';
    const ticketTypeLabel = `${getTicketType(ticket.type)}${eventsCount ? ` (${eventsCount})` : ''}`;

    function cashout() {
        myBetsContext.showPreCashoutDisclaimer(ticket.id, ticket.amount, ticket.cashoutAmount, ticket.isLive);
    }

    return (
        <>
            <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_1">
                {ticket.openedEventsNumber > 0 && ticket.totalEventsNumber > 0 &&
                    <div className="d-flex flex-column text-small betinfo__selections | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.selezioni_aperte')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{`${ticket.openedEventsNumber}/${ticket.totalEventsNumber}`}</span>
                    </div>
                }
                <div className="d-flex flex-column text-small | mb_5_3_1_1">
                    <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.importo')}</span>
                    <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(ticket.amount, conf.cs.m, conf.cs.nd)} {currency}
                        {amountAltCurr && <span> / {amountAltCurr}</span>}
                    </span>
                </div>
                {bonusAmount > 0 &&
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('general.bonus')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(bonusAmount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                }
                {totalOdd > 0 &&
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.quotatotale')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{oddToString(totalOdd)}</span>
                    </div>
                }
                <Winnings {...ticket} />
            </div>
            <hr className="mb_4" />
            {isCashoutable &&
                <>
                    <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_4">
                        <div className="d-flex flex-column text-small var-disclaimer var-disclaimer-wh | mb_5_3_4_1">
                            <span className="text-medium bold | mb_5_3_4_1_1">
                                {disclaimerCashout} {conf.iwh && amountWithCurrency}
                            </span>
                        </div>
                        <button onClick={cashout} className="bottone bet-info bg-verde bianco maiuscolo bet-info-wh | mb_5_3_4_2">
                            <span className="moneyIconContainer | mb_5_3_4_2_1" />
                            {getLabel('cashout.button_text')} {amountWithCurrency}
                        </button>
                    </div>
                    <hr className="mb_4" />
                </>
            }
            {!(window?.appConfig?.SHOP_MODE) && !props.isSnapshot &&
                <>
                    <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_2">
                        <div className="d-flex flex-column text-small var-disclaimer | mb_7">
                            <span className="bet-info-buttons-container justified-text text-medium bold | mb_7_1">
                                {!conf.sdt && printTicketEnabled &&
                                    <div className="my-bets-printer | mb_7_1_1" onClick={() => printerContext.printTicket(ticket.id, false)}>
                                        <img src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`} alt="Print button" className="mb_7_1_1_1" />
                                    </div>
                                }
                                <ShareCardDownloader
                                    ticketUrl={ticketUrl}
                                    ticketId={ticket.id}
                                    status={ticket.status}
                                    dateTimestamp={ticket.timestamp}
                                    totalOdd={oddToString(totalOdd)}
                                    totalAmount={getPrintableAmount(ticket.amount, conf.cs.m, conf.cs.nd)}
                                    winPot={getPrintableAmount(ticket.potentialWinnings, conf.cs.m, conf.cs.nd)}
                                    bonusAmount={bonusAmount > 0 ? `${getPrintableAmount(bonusAmount, conf.cs.m, conf.cs.nd)} ${currency}` : null}
                                    ticketTypeLabel={ticketTypeLabel}
                                />
                                <ReloadTicketSection isCheckbet={props.isCheckbet} ticket={props.ticket} />
                            </span>
                        </div>
                    </div>
                    <hr className="mb_4" />
                </>
            }
            <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey tuples-toggle | mb_5_3_3">
                <span className="mb_5_3_3_1">{getTicketType(ticket.type)}</span>
                <div className="d-flex justify-content-space-between | mb_5_3_3_2">
                    <span className="mb_5_3_3_2_1">Ref. {props.obfuscateTicketId ? getHiddenTicket(ticket.id) : ticket.id}</span>
                    <span className="margin-left-right | mb_5_3_3_2_2">|</span>
                    <span className="mb_5_3_3_2_3">{formatDate(ticket.timestamp).formatted}</span>
                </div>
            </div>
        </>
    );
}

export default BetInfo;